import convertImageUrl from '../../utils/proxy-util/convertImageUrl';
var proxyProfile = function (profileInfo) {
    var adultCertiDt = profileInfo.adultCertiDt, profileImgPath = profileInfo.profileImgPath, profileNm = profileInfo.profileNm, profileNo = profileInfo.profileNo, profileToken = profileInfo.profileToken, userNo = profileInfo.userNo, profilePwdYn = profileInfo.profilePwdYn, profileType = profileInfo.profileType;
    return {
        isMainProfile: profileType === 'M',
        adultCertificationDate: adultCertiDt !== null && adultCertiDt !== void 0 ? adultCertiDt : '',
        profileImageUrl: convertImageUrl(profileImgPath),
        profileName: profileNm,
        profileNo: profileNo,
        hasPassword: (profilePwdYn === null || profilePwdYn === void 0 ? void 0 : profilePwdYn.toUpperCase()) === 'Y',
        profileToken: profileToken,
        userNo: userNo,
    };
};
export default proxyProfile;
